import React, { useEffect, useState } from "react";
import { withUser } from "@coverme/identity";
import { Birdseed } from "@coverme/elements";
import { connect } from "react-redux";
import { CTA } from "@coverme/forms";
import * as retrocheckActions from "../../actions/retrocheckActions";
import "../../components/Retrocheck/Retrocheck.scss"
import { Link } from "react-router-dom";
import { RetrocheckFacesheetTop } from "../../components/Retrocheck/RetrocheckFacesheetTop";
import { LoadingBar } from "../../components/LoadingComponents/LoadingBar";
import { RetrocheckFacesheetAccordion } from "../../components/Retrocheck/RetrocheckFacesheetAccordion"
import * as retrocheckService from "../../services/retrocheckService";
import { toast } from "react-toastify";

export const RetrocheckFacesheetComponent = ({
    getPatientData,
    user,
    fileId,
    rowNumber,
    getPatientFindings,
    getPatients,
    isPatientFindingsLoading,
    isPatientDataLoading,
    isRetrocheckPatientsLoading,
}) => {
    const [patientData, setPatientData] = useState({});
    const [patientFindings, setPatientFindings] = useState({});
    const [isPatientExported, setIsPatientExported] = useState(true);
    const [patients, setPatients] = useState([]);

    useEffect(() => {
        getPatientData(fileId, rowNumber).then((data) => {
            setPatientData(data.data);

        });
        getPatientFindings(fileId, rowNumber).then((data) => {
            setPatientFindings(data.data);
        });
    }, [fileId, rowNumber]);

    useEffect(() => {
        if (patientData?.mrn) {
            getExportedToMarketplaceStatus();
            getPatients(patientData?.mrn).then((data) => {
                setPatients(data.data);
            });
        }
    }, [patientData]);

    function getExportedToMarketplaceStatus() {
        retrocheckService.getExportedToMarketplaceStatus(patientData?.mrn).then((info) => {
            if (info?.data?.result == "false") {
                setIsPatientExported(false);
            }
            else {
                setIsPatientExported(true);
            }
        })
    }
    function setExportedToMarketplaceStatus() {
        retrocheckService.setExportedToMarketplaceStatus(patientData?.mrn).then((info) => {
            if (info?.data?.result == "false") {
                setIsPatientExported(false);
            }
            else {
                setIsPatientExported(true);
            }
        })
    }

    function navigateBack() {
        window.history.back();
    }
    function moveToMatketplace() {
        retrocheckService.movePatientToMarketPlace(patientData).then((data) => {
            setExportedToMarketplaceStatus();
            getExportedToMarketplaceStatus();
            toast.success("Patient Moved to Marketplace.");
        });
    }

    return (
        <div>
            <Birdseed>
                <Link to="/" className="link">
                    Home
                </Link>
                <Link to="/retrocheck" className="link">
                    Retrocheck
                </Link>
                <a href="javascript:void(0)">Face Sheet</a>
            </Birdseed>
            <LoadingBar isLoading={isPatientFindingsLoading || isPatientDataLoading}>
                <div className="facesheet__container">
                    <div className="facesheet__buttons">
                        <CTA disabled={false} size={"large"} ctaType={"button"} styleType={"blue"} click={navigateBack}>
                            Back
                        </CTA>

                        <CTA disabled={isPatientExported} size={"large"} ctaType={"button"} styleType={"blue"} click={moveToMatketplace}>
                            Move to Marketplace
                        </CTA>

                        {/* <CTA disabled={false} size={"large"} ctaType={"button"} styleType={"blue"} click={() => undefined}>
                            Download/Print Facesheet
                        </CTA> */}
                    </div>
                    <div className="facesheet__sheet">
                        <RetrocheckFacesheetTop patient={patientData} />
                        <RetrocheckFacesheetAccordion patient={patientData} patientCoverages={patientFindings} patients={patients} />
                    </div>
                </div>
            </LoadingBar>
        </div>
    );
};

export const RetrocheckFacesheetComponentWithUser = withUser(RetrocheckFacesheetComponent);

export const RetrocheckFacesheetContainer = connect(
    (state, ownProps) => {
        return {
            fileId: ownProps.match.params.fileId,
            rowNumber: ownProps.match.params.rowNumber,
            isPatientFindingsLoading: state.patientFindings.isLoading === true || state.patientFindings.isInitialized === false,
            isPatientDataLoading: state.patientData.isLoading === true || state.patientData.isInitialized === false,
            isRetrocheckPatientsLoading: state.retrocheckPatients.isLoading === true || state.retrocheckPatients.isInitialized === false,
        };
    },
    dispatch => ({
        getPatientData: (fileId, rowNumber) => dispatch(retrocheckActions.getPatientData(fileId, rowNumber)),
        getPatientFindings: (fileId, rowNumber) => dispatch(retrocheckActions.getPatientFindings(fileId, rowNumber)),
        getPatients: (mrn) => dispatch(retrocheckActions.getPatientsForMrn(mrn)),
    })
)(RetrocheckFacesheetComponentWithUser);